import { createIcon } from '@chakra-ui/icons';

export const Money = createIcon({
  displayName: 'Money',
  viewBox: '0 0 16 16',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_151_4049)">
        <path
          d="M15.3333 4H0.666626V14.6667H15.3333V4Z"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8 11.3333C9.10457 11.3333 10 10.4379 10 9.33334C10 8.22877 9.10457 7.33334 8 7.33334C6.89543 7.33334 6 8.22877 6 9.33334C6 10.4379 6.89543 11.3333 8 11.3333Z"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M14 1.33334H2"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_151_4049">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
